// 使用import语句导入图片
import apechain from '@/app/assets/image/token/apechain.png';
import aptos from '@/app/assets/image/token/aptos.png';
import arbitrum from '@/app/assets/image/token/arbitrum.png';
import avalanche from '@/app/assets/image/token/avalanche.png';
import b2 from '@/app/assets/image/token/b2.png';
import base from '@/app/assets/image/token/base.png';
import berachain from '@/app/assets/image/token/berachain.png';
import bitlayer from '@/app/assets/image/token/bitlayer.png';
import blast from '@/app/assets/image/token/blast.png';
import bob from '@/app/assets/image/token/bob.png';
import bsc from '@/app/assets/image/token/bsc.png';
import chiliz from '@/app/assets/image/token/chiliz.png';
import conflux from '@/app/assets/image/token/conflux.png';
import cronos from '@/app/assets/image/token/cronos.png';
import ethereumPow from '@/app/assets/image/token/ethereum-pow.png';
import ethereum from '@/app/assets/image/token/ethereum.png';
import fantom from '@/app/assets/image/token/fantom.png';
import gnosis from '@/app/assets/image/token/gnosis.png';
import immutable from '@/app/assets/image/token/immutable.png';
import iotex from '@/app/assets/image/token/iotex.png';
import linea from '@/app/assets/image/token/linea.png';
import manta from '@/app/assets/image/token/manta.png';
import mantle from '@/app/assets/image/token/mantle.png';
import merlin from '@/app/assets/image/token/merlin.png';
import mode from '@/app/assets/image/token/mode.png';
import oktc from '@/app/assets/image/token/oktc.png';
import opbnb from '@/app/assets/image/token/opbnb.png';
import optimism from '@/app/assets/image/token/optimism.png';
import polygonZkevm from '@/app/assets/image/token/polygon-zkevm.png';
import polygon from '@/app/assets/image/token/polygon.png';
import pulsechain from '@/app/assets/image/token/pulsechain.png';
import scroll from '@/app/assets/image/token/scroll.png';
import seiEvm from '@/app/assets/image/token/sei-evm.png';
import solana from '@/app/assets/image/token/solana.png';
import sonic from '@/app/assets/image/token/sonic.png';
import starknet from '@/app/assets/image/token/starknet.png';
import sui from '@/app/assets/image/token/sui.png';
import taiko from '@/app/assets/image/token/taiko.png';
import ton from '@/app/assets/image/token/ton.png';
import tron from '@/app/assets/image/token/tron.png';
import unichain from '@/app/assets/image/token/unichain.png';
import xLayer from '@/app/assets/image/token/x-layer.png';
import zetachain from '@/app/assets/image/token/zetachain.png';
import zksyncEra from '@/app/assets/image/token/zksync-era.png';
import all from '@/app/assets/image/token/all.png';
import okb from '@/app/assets/image/token/okb.png';
import bnb from '@/app/assets/image/token/bnb.png';
import usdt from '@/app/assets/image/token/usdt.png';
import usdc from '@/app/assets/image/token/usdc.png';
import btc from '@/app/assets/image/token/btc.png';
import doge from '@/app/assets/image/token/doge.png';
import pump from '@/app/assets/image/token/pump.png';
import hyperliquid from '@/app/assets/image/token/hyperliquid.png';
import polymarket from '@/app/assets/image/dex/polymarket.png';

export const chainImgs: Record<string, any> = {
  polymarket,
  all,
  apechain,
  aptos,
  arbitrum,
  avalanche,
  b2,
  base,
  berachain,
  bitlayer,
  blast,
  bob,
  bsc,
  chiliz,
  conflux,
  cronos,
  ethereumPow,
  ethereum,
  fantom,
  gnosis,
  immutable,
  iotex,
  linea,
  manta,
  mantle,
  merlin,
  mode,
  oktc,
  opbnb,
  optimism,
  polygonZkevm,
  polygon,
  pulsechain,
  scroll,
  seiEvm,
  solana,
  sonic,
  starknet,
  sui,
  taiko,
  ton,
  tron,
  unichain,
  xLayer,
  zetachain,
  zksyncEra,
  okb,
  bnb,
  usdt,
  usdc,
  btc,
  doge,
  pump,
  hyperliquid,
};

export const chainIcons: Record<number | string, any> = {
  '-1': hyperliquid,
  137: polygon,
  195: tron,
  43114: avalanche,
  1: ethereum,
  66: oktc,
  56: bsc,
  250: fantom,
  42161: arbitrum,
  10: optimism,
  25: cronos,
  501: solana,
  324: zksyncEra,
  1030: conflux,
  784: sui,
  1101: polygonZkevm,
  59144: linea,
  5000: mantle,
  8453: base,
  534352: scroll,
  196: xLayer,
  169: manta,
  1088: null,
  7000: zetachain,
  4200: merlin,
  81457: blast,
  607: ton,
  146: sonic,
};
